// react toastify
import 'react-toastify/dist/ReactToastify.css';
// Import Swiper styles
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/grid';

// cursor
import './utils/cursor';

// i18n
import './i18n';

import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import {PersistGate} from 'redux-persist/lib/integration/react';
//
import SplashScreen from './components/loading-screen/SplashScreen';

import App from './App';
import { store } from './store';


import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { SettingsProvider } from './contexts/SettingsContext';

// Import components
/* =========================================================================== */

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.debug = () => {}
}

// 1. 【核心修改】从 meta 标签获取 Nginx 注入的动态 nonce
// 这里的 property="csp-nonce" 必须和 index.html 里的一致
const getNonce = () => {
  const nonceMeta = document.querySelector('meta[property="csp-nonce"]');
  if (nonceMeta && nonceMeta.content && nonceMeta.content !== '**CSP_NONCE_PLACEHOLDER**') {
    return nonceMeta.content;
  }
  const script = document.querySelector('script[nonce]');
  return script ? script.nonce || script.getAttribute('nonce') : undefined;
};
const cspNonce = getNonce();

// 2. 创建 Emotion Cache 并注入 Nonce
const muiCache = createCache({
  key: 'css', // 建议改简短一点，默认为 css
  nonce: cspNonce, // 关键：告诉 Emotion 生成的所有 <style> 标签都要带上这个 nonce
  prepend: true,
});


const root = ReactDOM.createRoot(document.getElementById('root'));

/* root.render(
  <Provider store={store}>
    <HelmetProvider>
      <BrowserRouter basename={PATH_CONFIG.basename}>
        <Suspense fallback={<SplashScreen />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
); */

root.render(
  <CacheProvider value={muiCache}>
    <Provider store={store}>
      <SettingsProvider>
        <HelmetProvider>
          <Suspense fallback={<SplashScreen />}>
            <App />
          </Suspense>
        </HelmetProvider>
      </SettingsProvider>
    </Provider>
  </CacheProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
